import { render, staticRenderFns } from "./AutoScrollWrapper.vue?vue&type=template&id=879d5f30&scoped=true&"
import script from "./AutoScrollWrapper.vue?vue&type=script&lang=js&"
export * from "./AutoScrollWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879d5f30",
  null
  
)

export default component.exports